import { cssVariables } from 'styles/root';
import styled from 'styled-components';
import { Divider, Collapse } from 'antd';
import Button from 'components/Button';

const { Panel } = Collapse;

export const StyledCodeButton = styled(Button)`
  background-color: ${cssVariables.primaryBlue} !important;
  text-transform: capitalize;
  max-width: 200px;
  color: #fff !important;

  &.secondary {
    color: ${cssVariables.primaryBlue} !important;
    background-color: transparent !important;
  }

  & span {
    font-weight: ${cssVariables.font.normal};
    letter-spacing: 0px;
  }
`;

export const StyledActionBtns = styled.div`
  display: flex;
  column-gap: 10px;

  & button {
    text-transform: capitalize;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 20px;
`;

export const StyledEncircledNumber = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid ${cssVariables.gray1};
  text-align: center;
  color: #0c3980;
  font-wize: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 5px;
`;

export const StyledSnippets = styled.div`
  background: rgb(191, 221, 255, 0.1);
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 10px;

  & > * {
    opacity: 1;
  }

  & span {
    display: flex;
    margin: 5px 0;
  }
`;

export const StyledCodeBlock = styled.div`
  max-width: 100%;
  border-radius: 5px;

  & pre {
    max-width: 100%;
    width: 100%;
    word-break: break-all;
  }
`;

export const StyledApiKeyContainer = styled.div`
  width: 100%;

  & form {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const StyledApiKeySubContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

export const StyledCollapsiblePanel = styled(Panel)`
  & .ant-collapse-content-box {
    padding: 30px;
  }
`;

export const StyledCollapsiblePanelHeader = styled.div`
  display: flex;
  align-items: center;

  & span {
    font-size: 24px;
  }
`;

export const StyledPanelSubHeader = styled.div`
  margin-bottom: 10px;
  color: ${cssVariables.gray0};
  font-weight: 700;
  font-size: 20px;
`;

export const StyledPageTitle = styled.div`
  text-align: left;
  width: 100%;
  & h3 {
    display: flex;
    width: 100%;
    font-size: 24px;
    font-weight: ${cssVariables.font.normal};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  height: auto;
  background: #fff;
  padding: 30px;
  width: 100%;
  flex-direction: column;

  & .ant-alert {
    margin: 20px;
  }

  & h2 {
    font-size: 18px;
    font-weight: ${cssVariables.font.normal};
  }
`;
